import api from './api';

export const locationService = {
  // ── Countries ─────────────────────────────────────────────────────────────
  getCountries: async (params = {}) => {
    const response = await api.get('/locations/countries', { params });
    return response.data;
  },
  getCountryById: async (id) => {
    const response = await api.get(`/locations/countries/${id}`);
    return response.data;
  },
  createCountry: async (data) => {
    const response = await api.post('/locations/countries', data);
    return response.data;
  },
  updateCountry: async (id, data) => {
    const response = await api.put(`/locations/countries/${id}`, data);
    return response.data;
  },
  toggleCountryStatus: async (id) => {
    const response = await api.patch(`/locations/countries/${id}/toggle-status`);
    return response.data;
  },

  // ── States ────────────────────────────────────────────────────────────────
  getStates: async (params = {}) => {
    const response = await api.get('/locations/states', { params });
    return response.data;
  },
  getStateById: async (id) => {
    const response = await api.get(`/locations/states/${id}`);
    return response.data;
  },
  createState: async (data) => {
    const response = await api.post('/locations/states', data);
    return response.data;
  },
  updateState: async (id, data) => {
    const response = await api.put(`/locations/states/${id}`, data);
    return response.data;
  },
  toggleStateStatus: async (id) => {
    const response = await api.patch(`/locations/states/${id}/toggle-status`);
    return response.data;
  },

  // ── Cities ────────────────────────────────────────────────────────────────
  getCities: async (params = {}) => {
    const response = await api.get('/locations/cities', { params });
    return response.data;
  },
  getCityById: async (id) => {
    const response = await api.get(`/locations/cities/${id}`);
    return response.data;
  },
  createCity: async (data) => {
    const response = await api.post('/locations/cities', data);
    return response.data;
  },
  updateCity: async (id, data) => {
    const response = await api.put(`/locations/cities/${id}`, data);
    return response.data;
  },
  toggleCityStatus: async (id) => {
    const response = await api.patch(`/locations/cities/${id}/toggle-status`);
    return response.data;
  },

  // ── PIN Codes ─────────────────────────────────────────────────────────────
  getPinCodes: async (params = {}) => {
    const response = await api.get('/locations/pincodes', { params });
    return response.data;
  },
  getPinCodeById: async (id) => {
    const response = await api.get(`/locations/pincodes/${id}`);
    return response.data;
  },
  resolvePinCode: async (pinCode) => {
    const response = await api.get(`/locations/resolve-pincode/${pinCode}`);
    return response.data;
  },
  createPinCode: async (data) => {
    const response = await api.post('/locations/pincodes', data);
    return response.data;
  },
  updatePinCode: async (id, data) => {
    const response = await api.put(`/locations/pincodes/${id}`, data);
    return response.data;
  },
  togglePinCodeStatus: async (id) => {
    const response = await api.patch(`/locations/pincodes/${id}/toggle-status`);
    return response.data;
  },

  // ── Addresses ─────────────────────────────────────────────────────────────
  getAddresses: async (params = {}) => {
    const response = await api.get('/locations/addresses', { params });
    return response.data;
  },
  getAddressById: async (id) => {
    const response = await api.get(`/locations/addresses/${id}`);
    return response.data;
  },
  createAddress: async (data) => {
    const response = await api.post('/locations/addresses', data);
    return response.data;
  },
  updateAddress: async (id, data) => {
    const response = await api.put(`/locations/addresses/${id}`, data);
    return response.data;
  },
  toggleAddressStatus: async (id) => {
    const response = await api.patch(`/locations/addresses/${id}/toggle-status`);
    return response.data;
  }
};

export default locationService;
